// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"0b8b7016","40":"ca5ad5ce","62":"0138cd6a","175":"f06b8401","373":"adf24ab1","426":"d6116911","521":"43e228e5","526":"5fdee37d","573":"c26b0d44","604":"6ffb5d62","953":"a33f4cdb"}[chunkId] + ".chunk.js";
};